import { render, staticRenderFns } from "./RichContent.vue?vue&type=template&id=0b6ad614&"
import script from "./RichContent.vue?vue&type=script&lang=js&"
export * from "./RichContent.vue?vue&type=script&lang=js&"
import style0 from "@/css/editor_content.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports